import React, { useState, useEffect, useRef } from "react";
import IncludeSideBar from "../../Components/Sidebar/IncludeSideBar";
import VoiceNotificationRecorder from "./VoiceNotificationRecorder";

const AdminNotificationPanel = () => {
  const AllNotificationUser = require("../../apis/notification");
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [color, setColor] = useState("#333333");
  const [body, setBody] = useState("");
  const [picturelink, setpicturelink] = useState("");
  const [buttonlink, setbuttonlink] = useState("");
  const [buttontext, setbuttontext] = useState("");
  const [buttoncolor, setButtoncolor] = useState("#FF0000");
  const [soundEnabled, setSoundEnabled] = useState(false);
  const [vibrationEnabled, setVibrationEnabled] = useState(false);
  const [importance, setImportance] = useState("DEFAULT");
  const [iconFile, setIconFile] = useState(null);
  const [pictureFile, setPictureFile] = useState(null);
  const [videoFile, setVideoFile] = useState(null);
  const [voiceFile, setVoiceFile] = useState(null);
  const [voiceBusy, setVoiceBusy] = useState(false);
  const [sending, setSending] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [inputPageNumber, setInputPageNumber] = useState("");
  const [inputFocus, setInputFocus] = useState(false);
  const [buttonFocus, setButtonFocus] = useState(false);
  const [pageWindow, setPageWindow] = useState({ start: 1, end: 20 });
  const [allUserId, setAllUserId] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const editableDivRef = useRef(null);
  const [showEmojiBox, setShowEmojiBox] = useState(false);
  const [selectedColor, setSelectedColor] = useState("#000000");
  const [fontSize, setFontSize] = useState(16);
  const [showLinkDialog, setShowLinkDialog] = useState(false);
  const [linkUrl, setLinkUrl] = useState("");
  const [savedSelection, setSavedSelection] = useState(null);
  const [sendEmail, setSendEmail] = useState(false);
  const [sendDreamSystem, setSendDreamSystem] = useState(true);

  const getUsers = async (page, searchTerm = "") => {
    try {
      const response = await AllNotificationUser.getNotificationUser(
        page,
        searchTerm,
      );
      setUsers(response.data);
      setFilteredUsers(response.data);
      setTotalPages(response.pagination.totalPages);
      setAllUserId(response.selectalluserid);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    getUsers(currentPage, searchTerm);
  }, [currentPage, searchTerm]);

  const handleSearch = (e) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);

    const filtered = users.filter(
      (user) =>
        user.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.email.toLowerCase().includes(searchTerm.toLowerCase()),
    );

    setFilteredUsers(filtered);
  };

  // ... (pagination functions remain the same)

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      setPageWindow({
        start: Math.floor((currentPage - 1) / 20) * 20 + 1,
        end: Math.min(Math.floor((currentPage - 1) / 20) * 20 + 20, totalPages),
      });
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setPageWindow({
        start: Math.floor((currentPage - 1) / 20) * 20 + 1,
        end: Math.min(Math.floor((currentPage - 1) / 20) * 20 + 20, totalPages),
      });
    }
  };

  const handleInput = () => {
    setBody(editableDivRef.current.innerHTML);
  };

  const handleNextPageWindow = () => {
    if (pageWindow.end < totalPages) {
      setPageWindow({
        start: pageWindow.start + 19,
        end: Math.min(pageWindow.end + 19, totalPages),
      });
    }
  };

  const handlePreviousPageWindow = () => {
    if (pageWindow.start > 1) {
      setPageWindow({
        start: pageWindow.start - 20,
        end: pageWindow.end - 20,
      });
    }
  };

  const handlePageClick = (page) => {
    handlePageChange(page);
    if (page === pageWindow.end && pageWindow.end < totalPages) {
      handleNextPageWindow();
    } else if (page === pageWindow.start && pageWindow.start > 1) {
      handlePreviousPageWindow();
    }
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
    setPageWindow({
      start: Math.floor((totalPages - 1) / 20) * 20 + 1,
      end: totalPages,
    });
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
    setPageWindow({
      start: 1,
      end: Math.min(20, totalPages),
    });
  };

  const handleGoToPage = () => {
    const pageNumber = parseInt(inputPageNumber, 10);
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      setPageWindow({
        start: Math.floor((pageNumber - 1) / 20) * 20 + 1,
        end: Math.min(Math.floor((pageNumber - 1) / 20) * 20 + 20, totalPages),
      });
      setInputPageNumber("");
    } else {
      alert(`Please enter a valid page number between 1 and ${totalPages}`);
    }
  };

  const handleSelectAll = (event, currentPage) => {
    const pageSize = 10;
    const maxSelectCount = 150;

    if (event.target.checked) {
      const selectedUserIds = [];
      let count = 0;

      const startIndex = (currentPage - 1) * pageSize;

      for (
        let i = startIndex;
        i < allUserId.length && count < maxSelectCount;
        i++
      ) {
        selectedUserIds.push(allUserId[i].id);
        count++;
      }
      setSelectedUsers(selectedUserIds);
    } else {
      setSelectedUsers([]);
    }
  };

  const handleSelectFilteredUser = (userId) => {
    if (!selectedUsers.includes(userId)) {
      setSelectedUsers([...selectedUsers, userId]);
    } else {
      setSelectedUsers(selectedUsers.filter((id) => id !== userId));
    }
  };

  const handleIconChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setIconFile(file);
    }
  };

  const handlePictureChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPictureFile(file);
    }
  };

  const handleVideoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type.startsWith("video/")) {
        setVideoFile(file);
      } else {
        alert("Please select a valid video file");
        event.target.value = "";
      }
    }
  };

  const sendNotificationToUsers = async (e) => {
    e.preventDefault();
    if (voiceBusy || sending) return;
    const formData = new FormData();
    formData.append("title", title);
    formData.append("subtitle", subtitle);
    formData.append("body", body);
    formData.append("color", color.replace("#", ""));
    formData.append("picturelink", picturelink);
    formData.append("buttonlink", buttonlink);
    formData.append("buttontext", buttontext);
    formData.append("buttoncolor", buttoncolor.replace("#", ""));
    formData.append("sound_enabled", soundEnabled ? "true" : "false");
    formData.append("vibration_enabled", vibrationEnabled ? "true" : "false");
    formData.append("importance", importance);
    formData.append("send_email", sendEmail ? "true" : "false");
    formData.append("send_dream_system", sendDreamSystem ? "true" : "false");

    selectedUsers.forEach((user) => {
      formData.append("id", user);
    });

    if (iconFile) {
      formData.append("large_icon", iconFile);
    }

    if (pictureFile) {
      formData.append("big_picture", pictureFile);
    }

    if (videoFile) {
      formData.append("video", videoFile);
    }

    if (voiceFile) {
      formData.append("voice", voiceFile);
    }

    setSending(true);
    try {
      const response = await AllNotificationUser.sendNotification(formData);
      alert("Notification sent successfully!");

      // Reset form
      setTitle("");
      setSubtitle("");
      setBody("");
      setColor("#FF0000");
      setpicturelink("");
      setbuttonlink("");
      setbuttontext("");
      setButtoncolor("#FFFFFF");
      setSoundEnabled(false);
      setVibrationEnabled(false);
      setImportance("DEFAULT");
      setIconFile(null);
      setPictureFile(null);
      setVideoFile(null);
      setVoiceFile(null);
      setSelectedUsers([]);
      setSendEmail(false);
      setSendDreamSystem(true);

      if (editableDivRef.current) {
        editableDivRef.current.innerHTML = "";
      }
    } catch (error) {
      console.error("Error sending notification:", error);
      alert("Failed to send notification");
    } finally {
      setSending(false);
    }
  };

  // Text formatting functions
  const changeTextColor = (color) => {
    const selection = window.getSelection();
    if (selection.toString().trim()) {
      const selectedText = selection.toString();
      const span = document.createElement("span");
      span.style.color = color;
      span.textContent = selectedText;

      const range = selection.getRangeAt(0);
      range.deleteContents();
      range.insertNode(span);

      handlebodyInput();
    }
  };

  const emojis = [
    "😊",
    "😂",
    "❤️",
    "👍",
    "🔥",
    "🥰",
    "😎",
    "🎉",
    "🤔",
    "🙌",
    "😢",
    "👏",
    "🥳",
    "😜",
    "😇",
    "😴",
    "🤗",
    "💪",
    "🙏",
    "😉",
  ];

  const insertEmoji = (emoji) => {
    const editableDiv = editableDivRef.current;
    setShowEmojiBox(false);

    if (editableDiv) {
      editableDiv.focus();
      const currentContent = editableDiv.innerHTML;
      editableDiv.innerHTML = currentContent + emoji;

      const range = document.createRange();
      const selection = window.getSelection();
      range.selectNodeContents(editableDiv);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);

      handlebodyInput();
    }
  };

  const applyBold = () => {
    const selection = window.getSelection();
    if (selection.toString().trim()) {
      const selectedText = selection.toString();
      const boldText = `<b>${selectedText}</b>`;

      const range = selection.getRangeAt(0);
      range.deleteContents();
      range.insertNode(
        document.createRange().createContextualFragment(boldText),
      );

      handlebodyInput();
    }
  };

  const applyItalic = () => {
    const selection = window.getSelection();
    if (selection.toString().trim()) {
      const selectedText = selection.toString();
      const italicText = `<i>${selectedText}</i>`;

      const range = selection.getRangeAt(0);
      range.deleteContents();
      range.insertNode(
        document.createRange().createContextualFragment(italicText),
      );

      handlebodyInput();
    }
  };

  const applyUnderline = () => {
    const selection = window.getSelection();
    if (selection.toString().trim()) {
      const selectedText = selection.toString();
      const underlineText = `<u>${selectedText}</u>`;

      const range = selection.getRangeAt(0);
      range.deleteContents();
      range.insertNode(
        document.createRange().createContextualFragment(underlineText),
      );

      handlebodyInput();
    }
  };

  // Link functionality - Now shows HTML tags
  const addLink = () => {
    const selection = window.getSelection();

    // Check if there's a valid selection in the editable div
    if (
      !selection.toString().trim() ||
      !editableDivRef.current.contains(selection.anchorNode)
    ) {
      alert("Please select some text in the message body to add a link");
      return;
    }

    // Save the current selection
    const range = selection.getRangeAt(0);
    setSavedSelection(range.cloneRange());
    setShowLinkDialog(true);
  };

  const removeLink = () => {
    const editableDiv = editableDivRef.current;
    if (editableDiv) {
      // Simple approach: remove all <a> tags and keep their content
      const content = editableDiv.innerHTML;
      const withoutLinks = content.replace(/<a[^>]*>(.*?)<\/a>/gi, "$1");
      editableDiv.innerHTML = withoutLinks;
      handlebodyInput();
    }
  };

  const applyLink = () => {
    if (!linkUrl.trim()) {
      alert("Please enter a URL");
      return;
    }

    if (!savedSelection) {
      alert("No text selection found. Please select text and try again.");
      return;
    }

    try {
      // Restore the selection
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(savedSelection);

      const selectedText = selection.toString();

      if (!selectedText.trim()) {
        alert("Selected text is empty. Please select some text and try again.");
        return;
      }

      // Add http:// if no protocol is specified
      let finalUrl = linkUrl.trim();
      if (!finalUrl.startsWith("http://") && !finalUrl.startsWith("https://")) {
        finalUrl = "https://" + finalUrl;
      }

      // Create the anchor tag as visible HTML
      const linkHTML = `<a href='${finalUrl}'>${selectedText}</a>`;

      // Apply the link
      const range = selection.getRangeAt(0);
      range.deleteContents();

      // Create a temporary container to parse the HTML
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = linkHTML;

      // Insert the link
      const fragment = document.createDocumentFragment();
      while (tempDiv.firstChild) {
        fragment.appendChild(tempDiv.firstChild);
      }
      range.insertNode(fragment);

      // Clean up
      handlebodyInput();
      setShowLinkDialog(false);
      setLinkUrl("");
      setSavedSelection(null);
    } catch (error) {
      console.error("Error applying link:", error);
      alert("Error applying link. Please try again.");
    }
  };

  const cancelLink = () => {
    setShowLinkDialog(false);
    setLinkUrl("");
  };

  const handlebodyInput = () => {
    const content = editableDivRef.current.innerHTML;
    setBody(content);
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const text = event.clipboardData.getData("text/plain");

    // Create a temporary div to handle the pasted content
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;

    // Insert as plain text with proper HTML encoding
    const encodedText = tempDiv.textContent || tempDiv.innerText || "";
    const cleanText = encodedText
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\n/g, "<br>");

    document.execCommand("insertHTML", false, cleanText);
    handlebodyInput();
  };

  // Inline styles
  const styles = {
    container: {
      padding: "20px",
      backgroundColor: "#f8f9fa",
      borderRadius: "8px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    },
    header: {
      fontSize: "24px",
      marginBottom: "20px",
      color: "#333",
    },
    searchBar: {
      marginBottom: "20px",
    },
    table: {
      borderCollapse: "collapse",
      marginBottom: "20px",
      width: "100%",
    },
    tableHeader: {
      backgroundColor: "#007bff",
      color: "#fff",
    },
    tableCell: {
      padding: "10px",
      borderBottom: "1px solid #ddd",
      textAlign: "left",
      color: "#000",
    },
    profilePic: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
    },
    pagination: {
      display: "flex",
      justifyContent: "center",
      marginTop: "20px",
      flexWrap: "wrap",
    },
    paginationButton: {
      margin: "0 5px",
      padding: "8px 12px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      cursor: "pointer",
      backgroundColor: "#007bff",
      color: "#fff",
    },
    activeButton: {
      backgroundColor: "#0056b3",
    },
    formGroup: {
      marginBottom: "15px",
    },
    formLabel: {
      display: "block",
      marginBottom: "5px",
      fontWeight: "bold",
    },
    formInput: {
      width: "100%",
      padding: "8px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      boxSizing: "border-box",
    },
    submitButton: {
      padding: "10px 20px",
      backgroundColor: "#28a745",
      border: "none",
      borderRadius: "4px",
      color: "#fff",
      cursor: "pointer",
      fontSize: "16px",
    },
    editableDiv: {
      border: "1px solid #ccc",
      padding: "10px",
      minHeight: "100px",
      fontSize: "16px",
      outline: "none",
      borderRadius: "5px",
      cursor: "text",
      backgroundColor: "#fff",
      fontFamily: "monospace", // Use monospace font to better see HTML tags
      whiteSpace: "pre-wrap", // Preserve formatting
    },
    toolbar: {
      marginBottom: "10px",
      display: "flex",
      gap: "5px",
      flexWrap: "wrap",
    },
    button: {
      padding: "5px 10px",
      cursor: "pointer",
      border: "1px solid #ccc",
      borderRadius: "4px",
      backgroundColor: "#f8f9fa",
    },
    linkButton: {
      padding: "5px 10px",
      cursor: "pointer",
      border: "1px solid #ccc",
      borderRadius: "4px",
      backgroundColor: "#007bff",
      color: "white",
    },
    removeLinkButton: {
      padding: "5px 10px",
      cursor: "pointer",
      border: "1px solid #ccc",
      borderRadius: "4px",
      backgroundColor: "#dc3545",
      color: "white",
    },
    emojiButton: {
      padding: "5px 10px",
      cursor: "pointer",
      border: "1px solid #ccc",
      borderRadius: "4px",
      backgroundColor: "#f8f9fa",
    },
    emojiBox: {
      display: showEmojiBox ? "flex" : "none",
      flexWrap: "wrap",
      gap: "5px",
      padding: "10px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      background: "#fff",
      position: "absolute",
      zIndex: 1000,
      maxWidth: "200px",
      maxHeight: "150px",
      overflowY: "auto",
    },
    linkDialog: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      padding: "20px",
      borderRadius: "8px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      zIndex: 1001,
      minWidth: "300px",
    },
    linkDialogOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    linkInput: {
      width: "100%",
      padding: "8px",
      marginBottom: "10px",
      border: "1px solid #ccc",
      borderRadius: "4px",
    },
    linkDialogButtons: {
      display: "flex",
      gap: "10px",
      justifyContent: "flex-end",
    },
    dialogButton: {
      padding: "8px 16px",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    },
    confirmButton: {
      backgroundColor: "#28a745",
      color: "white",
    },
    cancelButton: {
      backgroundColor: "#6c757d",
      color: "white",
    },
    emojiItem: {
      fontSize: "18px",
      cursor: "pointer",
      padding: "5px",
    },
    colorPicker: {
      width: "40px",
      height: "30px",
      border: "none",
      cursor: "pointer",
      borderRadius: "4px",
    },
    colorPickerGroup: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginBottom: "10px",
    },
    colorPreview: {
      width: "30px",
      height: "30px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      display: "inline-block",
      marginLeft: "10px",
    },
    fileInput: {
      padding: "5px",
    },
    checkboxGroup: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
  };

  return (
    <IncludeSideBar>
      <div style={styles.container}>
        <h2 style={styles.header}>Admin Notification Panel</h2>

        {/* User Search and Selection */}
        <div style={styles.searchBar}>
          <input
            type="text"
            placeholder="Search by Username or Email"
            value={searchTerm}
            onChange={handleSearch}
            style={styles.formInput}
          />
        </div>

        <table style={styles.table}>
          <thead style={styles.tableHeader}>
            <tr>
              <th style={styles.tableCell}>
                <input
                  type="checkbox"
                  onChange={(event) => handleSelectAll(event, currentPage)}
                  checked={selectedUsers.length > 0}
                />
              </th>
              <th style={styles.tableCell}>Profile Picture</th>
              <th style={styles.tableCell}>ID</th>
              <th style={styles.tableCell}>Username</th>
              <th style={styles.tableCell}>Email</th>
              <th style={styles.tableCell}>Account Type</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user) => (
              <tr key={user.id}>
                <td style={styles.tableCell}>
                  <input
                    type="checkbox"
                    checked={selectedUsers.includes(user.id)}
                    onChange={() => handleSelectFilteredUser(user.id)}
                    style={{
                      accentColor: selectedUsers.includes(user.id)
                        ? "#4CAF50"
                        : "",
                    }}
                  />
                </td>
                <td style={styles.tableCell}>
                  <img
                    src={user.profile_pic}
                    alt="Profile"
                    style={styles.profilePic}
                  />
                </td>
                <td style={styles.tableCell}>{user.id}</td>
                <td style={styles.tableCell}>{user.username}</td>
                <td style={styles.tableCell}>{user.email}</td>
                <td style={styles.tableCell}>{user.account_type}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination */}
        <div style={styles.pagination}>
          <button
            style={styles.paginationButton}
            onClick={handleFirstPage}
            disabled={currentPage === 1}
          >
            First
          </button>
          <button
            style={styles.paginationButton}
            onClick={handlePreviousPageWindow}
            disabled={pageWindow.start <= 1}
          >
            &lt;&lt;
          </button>
          {Array.from(
            { length: pageWindow.end - pageWindow.start + 1 },
            (_, i) => (
              <button
                key={pageWindow.start + i}
                style={{
                  ...styles.paginationButton,
                  ...(currentPage === pageWindow.start + i
                    ? styles.activeButton
                    : {}),
                }}
                onClick={() => handlePageClick(pageWindow.start + i)}
              >
                {pageWindow.start + i}
              </button>
            ),
          )}
          <button
            style={styles.paginationButton}
            onClick={handleNextPageWindow}
            disabled={pageWindow.end >= totalPages}
          >
            &gt;&gt;
          </button>
          <button
            style={styles.paginationButton}
            onClick={handleLastPage}
            disabled={currentPage === totalPages}
          >
            Last
          </button>
        </div>

        {/* Notification Form */}
        <form onSubmit={sendNotificationToUsers}>
          {/* Basic Notification Details */}
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Title:</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              style={styles.formInput}
              required
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Subtitle:</label>
            <input
              type="text"
              value={subtitle}
              onChange={(e) => setSubtitle(e.target.value)}
              style={styles.formInput}
            />
          </div>

          {/* Rich Text Body Editor */}
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Body:</label>

            {/* Text Formatting Toolbar */}
            <div style={styles.toolbar}>
              <input
                type="color"
                value={selectedColor}
                onChange={(e) => {
                  setSelectedColor(e.target.value);
                  changeTextColor(e.target.value);
                }}
                style={styles.colorPicker}
                title="Select Text Color"
              />
              <button
                type="button"
                style={styles.emojiButton}
                onClick={() => setShowEmojiBox(!showEmojiBox)}
                title="Add Emoji"
              >
                😊
              </button>
              <button type="button" style={styles.button} onClick={applyBold}>
                Bold
              </button>
              <button type="button" style={styles.button} onClick={applyItalic}>
                Italic
              </button>
              <button
                type="button"
                style={styles.button}
                onMouseDown={(e) => {
                  e.preventDefault();
                  applyUnderline();
                }}
                title="Underline Text"
              >
                Underline
              </button>
              <button
                type="button"
                style={styles.linkButton}
                onClick={addLink}
                title="Add Link"
              >
                🔗 Add Link
              </button>
              <button
                type="button"
                style={styles.removeLinkButton}
                onClick={removeLink}
                title="Remove Link"
              >
                Remove Link
              </button>

              {/* Emoji Box */}
              {showEmojiBox && (
                <div style={styles.emojiBox}>
                  {emojis.map((emoji, index) => (
                    <span
                      key={index}
                      style={styles.emojiItem}
                      onClick={() => insertEmoji(emoji)}
                    >
                      {emoji}
                    </span>
                  ))}
                </div>
              )}
            </div>

            {/* ContentEditable Div for rich text input */}
            <div
              ref={editableDivRef}
              contentEditable
              style={styles.editableDiv}
              onInput={handlebodyInput}
              onPaste={handlePaste}
              placeholder="Type your notification message here... You can use HTML tags like &lt;b&gt;bold&lt;/b&gt;, &lt;i&gt;italic&lt;/i&gt;, &lt;a href='url'&gt;link&lt;/a&gt;"
            />

            {/* Hidden textarea for form submission */}
            <textarea
              style={{ display: "none" }}
              value={body}
              readOnly
              name="body"
            />
          </div>

          {/* Link Dialog */}
          {showLinkDialog && (
            <>
              <div style={styles.linkDialogOverlay} onClick={cancelLink} />
              <div style={styles.linkDialog}>
                <h3>Add Link</h3>
                <input
                  type="url"
                  value={linkUrl}
                  onChange={(e) => setLinkUrl(e.target.value)}
                  placeholder="https://example.com"
                  style={styles.linkInput}
                  autoFocus
                />
                <div style={styles.linkDialogButtons}>
                  <button
                    style={{ ...styles.dialogButton, ...styles.cancelButton }}
                    onClick={cancelLink}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    style={{ ...styles.dialogButton, ...styles.confirmButton }}
                    onClick={applyLink}
                  >
                    Add Link
                  </button>
                </div>
              </div>
            </>
          )}

          {/* Notification Styling */}
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Notification Color:</label>
            <div style={styles.colorPickerGroup}>
              <input
                type="color"
                value={color}
                onChange={(e) => setColor(e.target.value)}
                style={styles.colorPicker}
                title="Select Notification Color"
              />
              <span>{color}</span>
              <div
                style={{
                  ...styles.colorPreview,
                  backgroundColor: color,
                }}
                title="Current color"
              ></div>
            </div>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Notification Importance:</label>
            <select
              value={importance}
              onChange={(e) => setImportance(e.target.value)}
              style={styles.formInput}
            >
              <option value="DEFAULT">DEFAULT</option>
              <option value="HIGH">HIGH</option>
              <option value="LOW">LOW</option>
              <option value="MIN">MIN</option>
            </select>
          </div>

          {/* Button Configuration */}
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Button Text:</label>
            <input
              type="text"
              value={buttontext}
              onChange={(e) => setbuttontext(e.target.value)}
              placeholder="Text to display on button"
              style={styles.formInput}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Button Link:</label>
            <input
              type="url"
              value={buttonlink}
              onChange={(e) => setbuttonlink(e.target.value)}
              placeholder="https://example.com"
              style={styles.formInput}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Button Color:</label>
            <div style={styles.colorPickerGroup}>
              <input
                type="color"
                value={buttoncolor}
                onChange={(e) => setButtoncolor(e.target.value)}
                style={styles.colorPicker}
                title="Select Button Color"
              />
              <span>{buttoncolor}</span>
              <div
                style={{
                  ...styles.colorPreview,
                  backgroundColor: buttoncolor,
                  border: buttoncolor === "#FFFFFF" ? "1px solid #ccc" : "none",
                }}
                title="Current button color"
              ></div>
            </div>
          </div>

          {/* Media Attachments */}
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Picture Link:</label>
            <input
              type="url"
              value={picturelink}
              onChange={(e) => setpicturelink(e.target.value)}
              placeholder="https://example.com/image.jpg"
              style={styles.formInput}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Large Icon (File):</label>
            <input
              type="file"
              onChange={handleIconChange}
              accept="image/*"
              style={styles.fileInput}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Big Picture (File):</label>
            <input
              type="file"
              onChange={handlePictureChange}
              accept="image/*"
              style={styles.fileInput}
            />
          </div>

          {/* Video Input */}
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Video Attachment:</label>
            <input
              type="file"
              onChange={handleVideoChange}
              accept="video/*"
              style={styles.fileInput}
            />
            {videoFile && (
              <p style={{ margin: "5px 0", color: "#28a745" }}>
                Selected: {videoFile.name}
              </p>
            )}
          </div>

          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Voice Notification:</label>
            <VoiceNotificationRecorder value={voiceFile} onChange={setVoiceFile} onBusyChange={setVoiceBusy} disabled={sending} />
          </div>

          {/* Delivery Channels */}
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Delivery Channels:</label>
            <div
              style={{
                display: "flex",
                gap: "24px",
                marginTop: "8px",
                padding: "12px 16px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                backgroundColor: "#fff",
              }}
            >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                  fontWeight: "normal",
                  margin: 0,
                }}
              >
                <input
                  type="checkbox"
                  checked={sendEmail}
                  onChange={(e) => setSendEmail(e.target.checked)}
                  style={{ width: "16px", height: "16px", cursor: "pointer" }}
                />
                📧 Send Email
              </label>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                  fontWeight: "normal",
                  margin: 0,
                }}
              >
                <input
                  type="checkbox"
                  checked={sendDreamSystem}
                  onChange={(e) => setSendDreamSystem(e.target.checked)}
                  style={{ width: "16px", height: "16px", cursor: "pointer" }}
                />
                🔔 Send to Dream System (Push + In-App)
              </label>
            </div>
          </div>

          {/* Notification Settings */}
          <div style={styles.formGroup}>
            <div style={styles.checkboxGroup}>
              <input
                type="checkbox"
                checked={soundEnabled}
                onChange={(e) => setSoundEnabled(e.target.checked)}
              />
              <label style={styles.formLabel}>Enable Sound</label>
            </div>
          </div>

          <div style={styles.formGroup}>
            <div style={styles.checkboxGroup}>
              <input
                type="checkbox"
                checked={vibrationEnabled}
                onChange={(e) => setVibrationEnabled(e.target.checked)}
              />
              <label style={styles.formLabel}>Enable Vibration</label>
            </div>
          </div>

          {/* Submit Button */}
          <button type="submit" style={styles.submitButton} disabled={voiceBusy || sending}>
            {sending ? "Sending…" : "Send Notification"}
          </button>
        </form>
      </div>
    </IncludeSideBar>
  );
};

export default AdminNotificationPanel;
